import React, { useState } from 'react';
import { ClipPrompt } from '../../../api/structs/clip';
import NarratorTrack from './NarratorTrack';

interface AdvancedSettingsProps {
  clipId: string;
  clip: ClipPrompt;
  onRefresh: () => void;
}

const AdvancedSettings: React.FC<AdvancedSettingsProps> = ({ clipId, clip, onRefresh }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="border border-white/10 bg-black">
      <button
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 text-xs uppercase tracking-[0.2em] text-zinc-500 hover:text-zinc-300 transition-colors font-mono"
      >
        <span>Advanced Settings</span>
        <span>{expanded ? '−' : '+'}</span>
      </button>
      {expanded && (
        <div className="border-t border-white/10 p-4">
          <NarratorTrack clipId={clipId} clip={clip} onRefresh={onRefresh} />
        </div>
      )}
    </div>
  );
};

export default AdvancedSettings;
